import { VCard } from 'vuetify/lib/components/VCard';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VCard,
    {
      staticClass: "d-flex rounded-t discount-banner",
      class: _setup.isMobile
        ? "flex-column pa-4"
        : "justify-space-between align-center pa-6 discount-banner__desktop-height",
      attrs: { flat: "" },
    },
    [
      _c(
        "div",
        {
          class: {
            "d-flex justify-space-between discount-banner__body":
              _setup.isMobile,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "text--text",
              class: _setup.isMobile ? "text-subtitle-1" : "text-h6",
            },
            [
              _vm._v(
                "\n      Скидка на анализы " +
                  _vm._s(_vm.discount) +
                  "% при оформлении заказа на ПроДокторов\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(_setup.iconIfMobile, { tag: "component" }),
        ],
        1
      ),
      _vm._v(" "),
      _c(_setup.btnIfMobile, { tag: "component" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }